import React from "react";
import { Fab, Zoom } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

export default function FloatingFilterFab({ visible, onClick }) {
  return (
    <Zoom in={visible}>
      <Fab
        color="primary"
        onClick={onClick}
        aria-label="Open filters"
        sx={{
          position: "fixed",
          right: 16,
          bottom: 16,
          zIndex: (t) => t.zIndex.tooltip + 1,
          boxShadow: 6,
        }}>
        <FilterListIcon />
      </Fab>
    </Zoom>
  );
}
